import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { isValidRedirect } from '../lib/auth'
import { ROUTES } from '../lib/constants'
import { useAuth } from '../providers/Auth/Auth'
import { BlankLoadingPage } from './pages/BlankLoadingPage'

type ProtectedRouteProps = {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <BlankLoadingPage />
  }

  if (!isAuthenticated) {
    // Carry the query string too: the OAuth consent page is identified by a
    // `request_id` there, and dropping it would send the user back to a page
    // that no longer knows what it was asked to approve.
    const target = `${location.pathname}${location.search}`

    const redirectTo = isValidRedirect(target)
      ? `${ROUTES.logout}?redirectTo=${encodeURIComponent(target)}`
      : ROUTES.logout

    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
